export default class UploadFile {
	constructor({
		added_on,
		bucket_path,
		category,
		company_id,
		equivalent_fields,
		id,
		is_public,
		original_name,
		process_state,
		resource_id,
		total_routes,
		total_rows,
		update_on,
		upload_dararutas,
	}) {
		this.added_on = added_on ? added_on : "";
		this.bucket_path = bucket_path ? bucket_path : "";
		this.category = category ? category : "";
		this.company_id = company_id ? company_id : 0;
		this.equivalent_fields = equivalent_fields ? equivalent_fields : {};
		this.id = id ? id : 0;
		this.is_public = is_public ? is_public : 0;
		this.original_name = original_name ? original_name : "";
		this.process_state = process_state ? process_state : "";
		this.resource_id = resource_id ? resource_id : 0;
		this.total_routes = total_routes ? total_routes : 0;
		this.total_rows = total_rows ? total_rows : 0;
		this.update_on = update_on ? update_on : null;
		this.upload_dararutas = upload_dararutas ? upload_dararutas : 0;
	}

	downloadFile(filename, url) {
		return new Promise((resolve, reject) => {
			fetch(url)
				.then((resp) => {
					if (resp.status === 404) {
						throw new Error("Something was wrong");
					}
					return resp.blob();
				})
				.then((blob) => {
					const url = window.URL.createObjectURL(blob);
					const a = document.createElement("a");
					a.style.display = "none";
					a.href = url;
					// the filename you want
					a.download = filename;
					document.body.appendChild(a);
					a.click();
					window.URL.revokeObjectURL(url);
					resolve("ok");
				})
				.catch((err) => {
					reject(err);
				});
		});
	}
}
